import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { ActionButton } from "../../../../../../_metronic/_partials/controls/ActionButton";
import { FeatureItem } from "./FeatureItem";

const FeatureSchema = yup.object().shape({
  features: yup.array().of(
    yup.object({
      uuid: yup.string().required(),
      name: yup.string().required(),
      is_active: yup.string().required()
    })
  )
});

export function OrganizationFeatureEditForm({
  saveOrganizationFeature,
  loading,
  features = [],
  onHide
}) {
  function submit(values) {
    const { features } = values;

    saveOrganizationFeature(features);
  }

  function updateStatus(item, list, callback) {
    const itemIndex = list.findIndex(({ uuid }) => uuid === item.uuid);

    if (itemIndex < 0) {
      return;
    }

    const temp = [...list];
    const itemToUpdate = temp[itemIndex];

    temp[itemIndex] = { ...itemToUpdate, ...item };

    callback(temp);
  }

  return (
    <Formik
      enableReinitialize={[...features]}
      initialValues={{
        features
      }}
      validationSchema={FeatureSchema}
      onSubmit={submit}
    >
      {({ values, setFieldValue, errors }) => (
        <Form>
          <Modal.Body>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Fitur</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                {values.features.map(item => (
                  <FeatureItem
                    key={item.uuid}
                    item={item}
                    update={item =>
                      updateStatus(item, values.features, newList =>
                        setFieldValue("features", newList)
                      )
                    }
                  />
                ))}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-end">
              <ActionButton
                type="button"
                variant="secondary"
                className={"mr-3"}
                loading={loading}
                onClick={onHide}
                text="Batal"
              />
              <ActionButton
                type="submit"
                className={"mr-3"}
                loading={loading}
                text="Submit"
              />
            </div>
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  );
}
